import React from 'react';
import PropTypes from 'prop-types';

import { dig } from 'spiceutils';

import MultipleAnswers from './MultipleAnswers';
import SingleAnswer from './SingleAnswer';

/*
 * AnswersToShow
 *
 * Renders a SingleAnswer or a MultipleAnswer component depending on the type specified in the
 * control list.
 */
const AnswersToShow = (props) => {
  if (dig(props.controlList, ['AnswersToShow', 'Visible']) === true) {
    switch (props.controlList.AnswersToShow.Type) {
      case 'select':
        return <SingleAnswer {...props} />;
      case 'multiSelect':
        return <MultipleAnswers {...props} />;
      default:
        return null;
    }
  } else {
    return null;
  }
};

AnswersToShow.propTypes = {
  controlList: PropTypes.object,
};

export default AnswersToShow;



// WEBPACK FOOTER //
// ./app/components/FormControls/AnswersToShow/index.js